import { useEffect } from 'react';
import LangEnum from '../../../lang/LangEnum';
import { useLoadingStatusStore } from '../../../modules/context/loadingStatus/LoadingStatus.store';
import { LoadingStatus } from '../../../modules/context/loadingStatus/loadingStatus.store.types';
import { useTranslation } from '../../../modules/translation/TranslationContext';
import snackbarStore, { SnackbarMessageType } from '../../../stores/Snackbar.store';

interface LoadingStatusNotice {
  type: SnackbarMessageType;
  label: LangEnum;
  loading?: boolean;
}

const NOTICE_BY_STATUS: Record<LoadingStatus, LoadingStatusNotice> = {
  [LoadingStatus.LOADING]: { type: 'info', label: LangEnum.AUTOSAVE_SAVING, loading: true },
  [LoadingStatus.SAVED]: { type: 'success', label: LangEnum.AUTOSAVE_SAVED },
  [LoadingStatus.ERROR]: { type: 'error', label: LangEnum.AUTO_SAVE_ERROR_FORM_MESSAGE },
};

export const useLoadingStatusSnackbar = () => {
  const { translate } = useTranslation();

  useEffect(
    () =>
      useLoadingStatusStore.subscribe((state, previous) => {
        if (state.loadingStatus === previous.loadingStatus) {
          return;
        }

        const { label, ...notice } = NOTICE_BY_STATUS[state.loadingStatus];
        snackbarStore.handleMessage({ ...notice, message: translate(label) });
      }),
    [translate],
  );
};
